var componentRequireContext = require.context("components/myreports/Prospect", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
